module.exports = __webpack_public_path__ + "static/media/twitter_logo.ce1624eb.png";